import React from 'react';

import { useRefreshRSimDetailEntry } from './hooks/useRefreshRSimDetailEntry';
import { RSimEditDialog, RSimEditDialogContentProps } from 'src/rSimInventory/Edit/RSimEditDialog';
import { useRSimSuspenseQuery } from 'src/rSimInventory/hooks/useRSimSuspenseQuery';

type RSimProductsEditDialogProps = Omit<RSimEditDialogContentProps, 'onTagsChange' | 'data'> & {
  euicc: string;
};

export const RSimProductDetailsEditDialog = React.memo(
  ({ euicc, ...props }: RSimProductsEditDialogProps) => {
    const { data } = useRSimSuspenseQuery(euicc);

    const { refreshTags } = useRefreshRSimDetailEntry(euicc);

    if (data.items.length < 1) {
      throw new Error('no data');
    }

    return <RSimEditDialog {...props} data={data.items[0]} onTagsChange={refreshTags} />;
  },
);
